import { CardState } from '../types';
import Card from '../../card/Card';
import { useEffect, useState } from 'react';
import { ZOOMED_CARD_WIDTH, ZOOMED_CARD_HEIGHT } from '../constants';

interface ZoomedCardModalProps {
  card: CardState | null;
  onClose: () => void;
  onFlip?: (id: string) => void;
  width?: number;
  height?: number;
}

export default function ZoomedCardModal({
  card,
  onClose,
  onFlip,
  width = ZOOMED_CARD_WIDTH,
  height = ZOOMED_CARD_HEIGHT
}: ZoomedCardModalProps) {
  const [visible, setVisible] = useState(false);
  
  useEffect(() => {
    if (card) {
      setVisible(true);
    }
    return () => setVisible(false);
  }, [card]);

  if (!card) return null;

  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 300);
  };

  return (
    <div 
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm transition-opacity duration-300 ${
        visible ? 'opacity-100' : 'opacity-0'
      }`}
      onClick={handleClose}
    >
      <div 
        className={`relative transform transition-transform duration-300 ${
          visible ? 'scale-100' : 'scale-95'
        }`}
        onClick={(e) => e.stopPropagation()} // Prevent clicks on the card from closing the modal
      >
        {/* Controls */}
        <div className="absolute -top-12 right-0 flex space-x-2">
          <button 
            onClick={handleClose}
            className="p-2 rounded-full bg-white/20 hover:bg-white/30 backdrop-blur-md text-white transition-colors duration-200"
            aria-label="Close modal"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        {/* Card container with shadow and subtle glow */}
        <div className="transform-none rounded-lg overflow-hidden shadow-2xl" style={{ 
          position: 'relative', 
          transform: 'none',
          boxShadow: '0 0 30px rgba(0, 0, 0, 0.5), 0 0 15px rgba(255, 255, 255, 0.1)' 
        }}>
          <Card
            card={{
              ...card,
              position: { x: 0, y: 0 }, // Reset position for centered display
              rotation: 0, // Reset rotation for straight display
            }}
            onFlip={onFlip}
            isSelected={false}
            width={width}
            height={height}
            className="relative"
          />
        </div>
      </div>
    </div>
  );
} 
